module.exports = __webpack_public_path__ + "static/familia-local-shops-d4a8012bf4b9c8fa9bf9d0e52b683c0f.png";